/* David Pladen — sticky add-to-cart (assets/dp-bar.css, after hears.com).
 * Splits the bar's "colour · price" line into a small colour line above the
 * name and a price line below it, with the compare-at price when there is
 * one, and keeps both in step when another colour is chosen
 * (dp:variant:change from assets/dp-product.js).
 */

(() => {
  const build = () => {
    const bar = document.querySelector('[data-dp-bar]');
    if (!bar || bar.dataset.dpBarReady) return;
    bar.dataset.dpBarReady = 'true';
    const nm = bar.querySelector('.nm');
    const meta = bar.querySelector('[data-dp-bar-meta]');
    if (!nm || !meta) return;

    const kicker = document.createElement('small');
    kicker.className = 'bk';
    const price = document.createElement('span');
    price.className = 'bp';
    nm.prepend(kicker);
    nm.append(price);

    const set = (label, now, was) => {
      kicker.textContent = label;
      price.replaceChildren();
      if (was) {
        const s = document.createElement('s');
        s.textContent = was;
        price.append(s);
      }
      const n = document.createElement('span');
      n.textContent = now;
      if (was) n.className = 'sale';
      price.append(n);
    };

    const text = meta.textContent.trim();
    const cut = text.lastIndexOf(' · ');
    const compare = document.querySelector('[data-dp-compare]');
    set(
      cut > -1 ? text.slice(0, cut) : '',
      cut > -1 ? text.slice(cut + 3) : text,
      compare && !compare.hidden ? compare.textContent.trim() : ''
    );

    document.addEventListener('dp:variant:change', (event) => {
      const v = event.detail && event.detail.variant;
      if (v) set(v.label || '', v.price || '', v.compare || '');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
